import React from 'react';
import { Box } from '@mui/material';

/**
 * FlagImage component - Renders SVG flag images from URL
 * @param {string} flagUrl - SVG URL for the flag image
 * @param {string} alt - Alternative text for the image
 * @param {number} size - Height of the flag in pixels (default: 24)
 * @param {string} className - Additional CSS class names
 * @param {object} sx - MUI sx prop for additional styling
 */
const FlagImage = ({
  flagUrl,
  alt = "Country flag",
  size = 24,
  className = "",
  sx = {}
}) => {
  if (!flagUrl) {
    return null;
  }

  return (
    <Box
      component="img"
      src={flagUrl}
      alt={alt}
      className={className}
      sx={{
        height: size,
        width: 'auto',
        maxWidth: size * 1.6,
        display: 'inline-block',
        verticalAlign: 'middle',
        borderRadius: '2px',
        ...sx
      }}
      onError={(e) => {
        e.target.style.display = 'none';
      }}
    />
  );
};

export default FlagImage;
